/**
 * Разбор шаблона. Отдельно, потому что один и тот же объект приходит и
 * списком, и ответом на правку подписей.
 */

import type {Template, TemplateStatus} from './types';

type Raw = Record<string, unknown>;

export const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');
const asNullStr = (v: unknown): string | null => (typeof v === 'string' && v ? v : null);
/**
 * Список строк с сохранением позиций. Именно `map`, а не `filter`:
 * подписи переменных читаются по индексу плейсхолдера, и выброшенный
 * `null` в середине сдвинул бы все следующие — «Дата» уехала бы на
 * `{{2}}` и там же сохранилась.
 */
const asStrList = (v: unknown): string[] =>
  Array.isArray(v) ? v.map((x) => (typeof x === 'string' ? x : '')) : [];

const STATUSES: TemplateStatus[] = ['approved', 'pending', 'rejected', 'paused', 'disabled'];

/** Незнакомый статус — `disabled`: лучше не предложить отправку, чем предложить сломанную. */
const asStatus = (v: unknown): TemplateStatus =>
  STATUSES.includes(v as TemplateStatus) ? (v as TemplateStatus) : 'disabled';

export const toTemplate = (raw: unknown): Template => {
  const r = asObj(raw);
  return {
    id: asStr(r.id),
    metaName: asStr(r.metaName),
    title: asStr(r.title),
    lang: asStr(r.lang),
    category: asStr(r.category),
    bodyPreview: asStr(r.bodyPreview),
    variables: asStrList(r.variables),
    variableLabels: asStrList(r.variableLabels),
    status: asStatus(r.status),
    statusChangedAt: asNullStr(r.statusChangedAt),
    unavailableReason: asNullStr(r.unavailableReason),
    shared: r.shared === true,
  };
};
